import store, { history } from 'store';

// Actions
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as AttendanceActions from 'store/ducks/attendance/actions';
import * as DrawerActions from 'store/ducks/drawer/actions';
import * as LayoutActions from 'store/ducks/layout/actions';

// Helpers
import { setCompany, setUserType, getId } from 'helpers/auth';

// Constants
import AUTH from 'constants/auth';
import CONST_ATTENDANCE from 'constants/attendance';
import PATH from 'constants/basePath';

// WHEN MODIFYING THIS FILE, MAKE SURE ALL MODULES ARE WORKING !

/**
 * Redirects to the module(type) sent and make the necessary settings.
 * @param {String} type
 * @param {String} companyId
 */
async function redirectToModule(type: string, companyId?: string) {
  switch (type) {
    case AUTH.TYPES.SUPERVISOR.type:
      setUserType(AUTH.TYPES.SUPERVISOR.type);
      history.push(PATH.SELECT_WORKSPACE.BASE_URL);
      break;
    case AUTH.TYPES.COMPANY.type:
      setUserType(AUTH.TYPES.COMPANY.type);
      history.push(PATH.COMPANY_COLLABORATORS.BASE_URL);
      break;
    case AUTH.TYPES.ATTENDANT.type:
      setUserType(CONST_ATTENDANCE.USER_TYPES.ATTENDANT);
      setCompany(companyId);
      store.dispatch(
        AttendanceActions.getCurrentAttendantRequest({ ID: String(getId()) }),
      );
      history.push(PATH.ATTENDANCE.BASE_URL);
      break;
    case AUTH.TYPES.SCHOOL.type:
      setUserType(AUTH.TYPES.SCHOOL.type);
      store.dispatch(LayoutActions.setLayoutVisible({ visible: true }));
      store.dispatch(DrawerActions.setToggleDrawer({ open: true }));
      history.push(PATH.TEACHING_INSTITUTION_MODULE.BASE_URL);
      break;
    case AUTH.TYPES.TERMINAL.type:
      setUserType(AUTH.TYPES.TERMINAL.type);
      // promiseDispatch(
      //   SellingTerminalsActions.getSellingTerminalRequest({
      //     id: getId(),
      //     _includes: 'address,operator',
      //   }),
      // ).then((result) => {
      //   if (result) {
      // setCompany(result.transportOperatorId);
      store.dispatch(LayoutActions.setLayoutVisible({ visible: true }));
      store.dispatch(DrawerActions.setToggleDrawer({ open: true }));
      history.push(PATH.SELLING_POINTS.BASE_URL);
      //   }
      // });
      break;
    default:
      store.dispatch(
        SnackbarsActions.setOpen({
          open: true,
          type: 'error',
          message: 'Usuário inválido',
        }),
      );
      history.push('/');
      break;
  }
}

export { redirectToModule };
export default redirectToModule;
